import Toggle from '../../components/toggle/toggle.js';

export default class Toggles {
    constructor(el) {
        this.el = el;
        this.toggles = [];
        this.toggleElements = this.el.querySelectorAll('.toggle');

        this.initToggles();
    }

    initToggles() {
        for (var i = 0; i < this.toggleElements.length; i++) {
            this.toggles.push(new Toggle(this.toggleElements[i]));
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/toggles/toggles.js